<template>
  <NuxtImg
    loading="lazy"
    :class="[
      configData.SmallImage
        ? `w-[${parseInt(configData.SmallImage)}dvw]`
        : 'w-[7dvw]',
      configData.MediumImage
        ? `md:w-[${parseInt(configData.MediumImage)}dvw]`
        : 'md:w-[7dvw]',
      configData.LargeImage
        ? `3xl:w-[${parseInt(configData.LargeImage)}dvw]`
        : '3xl:w-[7dvw]',
    ]"
    :src="configData.ImageUrl"
    :alt="configData.ImageAlt ?? ''"
    :provider="
      configData.ImageUrl?.includes('cloudfront') ? 'cloudfront' : undefined
    "
  />
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    ImageUrl?: string;
    ImageAlt?: string;
    SmallImage?: string;
    MediumImage?: string;
    LargeImage?: string;
  };
}
defineProps<Props>();
</script>

<style scoped></style>
